import React, { useEffect, useState } from 'react';
import './storeSelect.scss';
import '../message/message.scss';
import { useDispatch } from 'react-redux';
import { resetSelection } from '../../actions/index';
import { postMessageToClient } from '../../widget/chatservice/communicationService';
import { addAnalyticsEvent } from '../chatservice/dialogflowQuery';
import { v4 } from 'uuid';
import { config } from '../../config/config.env';

type StoreSelectProps = {
    store: any,
    isHostDevice: boolean,
    chooseWinePreference: any,
    sessionId?: any,
    userId?: any,
}


const StoreSelect = ({store, isHostDevice, chooseWinePreference, sessionId, userId}: StoreSelectProps) => {
    const [timeStr1, timeStr2] = store.data.store_trading_hours || ['', ''];
    const [fawOpen, setFawOpen] = useState(false);
    const dispatch = useDispatch();
    
    const onClickHandler = (e: any) => {
        postMessageToClient({
            data : {
                linkName : 'web:chatbot:find a wine:select store',
                linkType: 'chatbot find a wine',
            },
            methodHandler : "chatbotTriggerAdobeAnalytics"
        });
        setFawOpen(true);
        chooseWinePreference(store.data.suburb.toLowerCase(), store.data.streetNumber, store.intentPayload.intentGroupId, store.intentPayload.intentGroupName, store.intentPayload.intentGroupTypeId);

        const analyticsData = {
            queryId : v4(),
            isSuccessful : null,
            eventName: 'STORE_SELECT',
            intentGroupId : store.intentPayload.intentGroupId,
            intentGroupName : store.intentPayload.intentGroupName,
            intentGroupTypeId : store.intentPayload.intentGroupTypeId,
            source : config.SOURCE
        };

        // FAW Set Store in Analytics
        addAnalyticsEvent(sessionId, userId, analyticsData);
    }

    useEffect(() => {
        fawOpen && dispatch(resetSelection());
    }, [fawOpen]);

    return (
            <div className='store'>
                <div className='store__location'>
                    <div className='store__title'>BWS <span className='store__suburb'>{store.data.name.toLowerCase()}</span></div>
                    <div className='store__address'>{store.data.addressLine1}</div>
                    <div className='store__address'><span className='store__suburb'>{store.data.suburb.toLowerCase()}</span> {store.data.postcode}</div>
                    {store.data.distance && <div className='store__address store__distance'>{store.data.distance}km away</div>}
                </div>
                <div className={'store__hours ' + (isHostDevice && 'store__hours--device')} >
                <div className='store__date'>
                    <span><b>{timeStr1}</b> {timeStr2 && '-'} {timeStr2}</span>
                </div>
                </div>

                <div className="message__text--qr">        
                <span onClick={onClickHandler} className="message__text--click" id="store-select-link">Select store</span>        
                </div>
            </div>
        );
}

export {
    StoreSelect
}